require('whatwg-fetch')